import React from 'react';
import { ultimasNoticias } from '../../json/ultimasNoticias';
import { useState,useEffect } from 'react';
import './ultimasnoticias.css';


const UltimasNoticias = () => {
  const[noticias, setNoticias] = useState([]);

  useEffect(() => {
    fetch('https://comunicacion-a.hidalgo.gob.mx/traer/notas', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => response.json())
      .then(data => {
        console.log(data.success.notas);
        if(data.success.notas.length > 0){
          setNoticias(data.success.notas);
        }
      })
      .catch(error => console.error(error));
  },[]);

  return (
    <div id='ultimas_noticias'>
      <div className='row'>
        <div className='col-12'>
          <div className='notice_section'>
            <div className='notice_title'>
              <h3 className='title'>ÚLTIMAS NOTICIAS</h3>
              <hr className='hr-gob'/>
            </div>
            <div className='notice_content'>
              <div className='col-sm-8 col-12'>
                <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                  <div className="carousel-inner">
                    {
                      ultimasNoticias.map((item, index)=>(
                        <div key={ index } className={ index >= 1 ? "carousel-item" : "carousel-item active" }>
                          <a href={ item.url } target="_blank" rel="noopener noreferrer">
                            <div className="img-carousel d-block w-100" style={{ backgroundImage: `url("${ item.imagen }")` }} alt="First slide">
                              <div className='title_img_carousel'>
                                <h6>{ item.titulo }</h6>
                                <p>{ item.fecha }</p>
                              </div>
                            </div>
                          </a>
                        </div>
                      ))
                    }
                  </div>
                  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
              <div className='col-md-4 col-12'>
                <div className='card_container'>
                  {
                    noticias.length > 0 ?
                    noticias.map((item, index)=>(
                      <div key={ index } className="card">
                        <div className="card-body">
                          <p className='card_date'>{new Date(item.date).toLocaleString()}</p>
                          <h5 className="card-title">{item.secretaria}</h5>
                          <h4 className="card-subtitle mb-2 text-muted">{item.title}</h4>
                          <p className="card-text">{item.descripcion}</p>
                          <a href={"https://comunicacion-a.hidalgo.gob.mx/detalles/" + item.id} target="_blank"rel="noopener noreferrer">Leer completo</a>
                        </div>
                      </div>
                    )) : null
                  }
                  <div class="col-sm-12 col-12">
				<div class="cont-noticias-cards">
        {/*
        <div class="card-noticias">	
						<p>Julio, 2024</p> 
						<h5>Pre-registro</h5>
						<h5>Curso de capacitación</h5>
						<p>
            Curso para reducir los siniestros de tránsito y mejorar la seguridad de las y los usuarios de la vía pública.
						</p>
						<a href="https://forms.gle/XseXY4L5PXzPRPgw8">Pre-registro</a>
					</div>
          <p></p>
          
         <div class="card-noticias">	
						<p>2025</p> 
						<h5>Convocatoria</h5>
						<h5>Convocatoria Para el registro de personas Profesionales y Profesionistas para expedir el estudio de impacto a la movilidad.</h5>
						<p>
               Mtra. Lyzbeth Robles Gutiérrez, Secretaria de Movilidad y Transporte del estado de Hidalgo, con fundamento en lo establecido en el Artículo 25 del Reglamento de la ley de Movilidad y Transporte para el Estado de Hidalgo, convoca:  
						</p>
						<a href="https://transparenciadocs.hidalgo.gob.mx/dependencias/Semot/dir3/Convocatoria_Profesionistas.pdf">Leer completo</a>
					</div>
         
        <div class="card-noticias">	
						<p>2025</p> 
						<h5>Concurso Nacional</h5>
						<h5>Transparencia en corto La Comisión Permanente de Contralores Estado-Federación (CPCE-F) convoca a participar en el XX Concurso Nacional Transparencia en Corto 2025</h5>
						<p>
               Mtra. Lyzbeth Robles Gutiérrez, Secretaria de Movilidad y Transporte del estado de Hidalgo, con fundamento en lo establecido en el Artículo 25 del Reglamento de la ley de Movilidad y Transporte para el Estado de Hidalgo, convoca:  
						</p>
						<a href="https://transparenciadocs.hidalgo.gob.mx/dependencias/Semot/dir3/2025/CS/TC_Conv_Nal_HGO.pdf">Leer completo</a>
					</div>
        */}
        

        <div class="card-noticias">	
						<p>2025</p> 
						<h5>Convocatoria</h5>
						<h5>Olimpiada Mexicana de Informática</h5>
						<p>
           El Protocolo Cero establece medidas especificas para prevenir conductas de acoso sexual y/o laboral y hostigamiento sexual y/o laboral en las Dependencias y Entidades de la Administración Pública Estatal, así como promover una cultura institucional de igualdad de género y un clima laboral libre de violencia.
						</p>
						<a href="https://seph.gob.mx/vistas/modulos/convocatorias/OHI/Convocatoria%20OHI%20Bachillerato.pdf">Leer completo</a>
					</div>
          

          
        
        <div class="card-noticias">	
						<p>Enero 2025</p> 
						<h5>Convocatoria</h5>
						<h5>Protocolo Cero</h5>
						<p>
            El Protocolo Cero establece medidas especificas para prevenir conductas de acoso sexual y/o laboral y hostigamiento sexual y/o laboral en las Dependencias y Entidades de la Administración Pública Estatal, así como promover una cultura institucional de igualdad de género y un clima laboral libre de violencia.
						</p>
						<a href="https://oficialiamayor.hidalgo.gob.mx/ProtocoloCero">Leer completo</a>
					</div>
          <p></p>
          
          <div class="card-noticias">
						<p> 2025 </p>
						<h5>Campaña</h5>
						<h5>Movilidad Responsable</h5>
						<p>
            De acuerdo a la Ley de Movilidad y Transporte para el Estado de Hidalgo, en su art. 26 determina la Jerarquía de la Movilidad, que prioriza en todo momento al peatón. 🚶🚴🚕🚛 🚗 #PeatonesPrimero #MovilidadResponsable.
						</p>
						<a href="/movilidad">Leer completo</a>
					</div>
          <p></p>
					<div class="card-noticias">	
						<p>2025</p>
						<h5>Campaña</h5>
						<h5>Formato para Quejas o Denuncias 2025</h5>
						<p>
            Este formato es un mecanismo para denunciar a servidores públicos de la Secretaría de Movilidad y Transporte cuya actuación la considere Usted como incongruente, respecto al comportamiento ético en el cumplimiento de sus actividades cotidianas o que pudiese conducir al posible incumplimiento de los preceptos establecidos en el Código de Ética o en el Código de Conducta de la SEMOT.
						</p>
						<a href="/Csii">Leer completo</a>
					</div>
         </div>
			</div>
    </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  )
}

export default UltimasNoticias